import { HomeMemberChangePasswordPage } from './HomeMemberChangePasswordPage';
export default HomeMemberChangePasswordPage;
